import { Controller } from '@hotwired/stimulus'
import { toast } from '../../helpers/custom_events_helper'

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.onClick)
  }

  onClick = event => {
    event.stopPropagation()
    const tempInput = document.createElement('input')
    tempInput.value = event.currentTarget.dataset.text || event.target.innerText
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    document.body.removeChild(tempInput)

    setTimeout(() => {
      toast({ message: 'Copied to clipboard!', delay: 3000 })
    }, 50)
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClick)
  }
}
